"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialsByName = exports.getFontSize = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getFontSize = function getFontSize(elem) {
  return parseInt(window.getComputedStyle(elem).getPropertyValue('font-size'), 10);
};

exports.getFontSize = getFontSize;

var getInitialsByName = function getInitialsByName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var withSecondName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ' ';

  if (typeof name === 'string' && name[0]) {
    var _name$split = name.split(separator),
        _name$split2 = _slicedToArray(_name$split, 2),
        _name$split2$ = _name$split2[0],
        firstName = _name$split2$ === void 0 ? '' : _name$split2$,
        _name$split2$2 = _name$split2[1],
        secondName = _name$split2$2 === void 0 ? '' : _name$split2$2;

    if (withSecondName) {
      return "".concat(firstName[0]).concat(secondName[0]);
    }

    return firstName[0];
  }

  return '';
};

exports.getInitialsByName = getInitialsByName;